import { render, staticRenderFns } from "./SMSVerificationDialog.vue?vue&type=template&id=3ac49856&scoped=true"
import script from "./SMSVerificationDialog.vue?vue&type=script&lang=js"
export * from "./SMSVerificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac49856",
  null
  
)

export default component.exports